import React from "react";
import { useUser } from "@/contexts/UserContext";
import { AuthedHome } from "./AuthedHome";
import { UnauthedHome } from "./UnauthedHome";

export const Home = () => {
  const { user } = useUser();

  return user ? <AuthedHome /> : <UnauthedHome />;
};
